<template>
  <v-container>
    <v-flex xs12 sm6 offset-sm3>
      <v-card>
        <v-card-text>
          <v-container v-if='!editMode'>
            <v-layout row>
              <v-flex xs12>
                <v-avatar class='teal' size='100px'>
                  <span v-if='avatar === ""' class='white--text headline'>{{avatarDefault}}</span>
                  <img v-else :src='avatar' />
                </v-avatar>
                <span class='black--text headline'>{{userInfo.userName}}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <span class='black--text headline'>Email: {{emailAddress}}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <span class='black--text headline'>First Name: {{userInfo.firstName}}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <span class='black--text headline'>Last Name: {{userInfo.lastName}}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <span class='black--text headline'>Organization: {{userInfo.organization}}</span>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <span class='black--text headline'>Short Bio:</span>
                <div class='black--text headline'>{{userInfo.bio}}</div>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs4>
                <v-btn outline @click.native='editMode = !editMode'>
                  edit Info
                </v-btn> 
              </v-flex>
            </v-layout> 
          </v-container>
          <v-container v-else='editmode'>
            <v-form @submit.prevent='onSetUserInfo'>
             <v-layout row v-show='!avatarDialog'  v-on:click='avatarDialog=!avatarDialog'>
              <v-flex xs12>
                <v-avatar class='teal' size='100px'>
                  <span v-if='tempAvatar === ""' class='white--text headline'>{{avatarDefault}}</span>
                  <img v-else :src='tempAvatar' />
                </v-avatar>
                <span class='black--text'>Click to add/change picture</span>
              </v-flex>

            </v-layout>
            <div v-show='avatarDialog'>
              <v-layout row>
                <v-flex xs4>
                  <vue-avatar
                  :width=400
                  :height=400
                  :borderRadius=400
                  ref="vueavatar"
                  @vue-avatar-editor:image-ready="onImageReady"
                  :image="image"
                  >
                </vue-avatar>
                <br>
                <vue-avatar-scale
                ref="vueavatarscale"
                @vue-avatar-editor-scale:change-scale="onChangeScale"
                :width=250
                :min=1
                :max=3
                :step=0.02
                >
              </vue-avatar-scale>
            </v-flex>
          </v-layout>

          <v-layout row>
            <v-flex xs6>
              <v-btn v-on:click="avatarEditDone" round color='success'>I like this picture</v-btn>
            </v-flex>
            <v-flex xs6>
              <v-btn v-on:click="revertTempAvatar" round color='warning'>Cancel edit</v-btn>
            </v-flex>
          </v-layout>
          <br>
        </div>

        <v-layout row>
          <v-flex xs12>
            <v-text-field
            name ='userName'
            label='User Name'
            id='userName'
            v-model='userName'
            type='text'
            required>
          </v-text-field>
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-text-field
          name ='firstName'
          label='First Name'
          id='firstName'
          v-model='firstName'
          type='text'
          required>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-text-field
        name ='lastName'
        label='Last Name'
        id='lastName'
        v-model='lastName'
        type='text'
        required>
      </v-text-field>
    </v-flex>
  </v-layout>
  <v-layout row>
    <v-flex xs12>
      <v-text-field
      name ='organization'
      label='Organization'
      id='organization'
      v-model='organization'
      type='text'>
    </v-text-field>
  </v-flex>
</v-layout>
  <v-layout row>
    <v-flex xs12>
      <v-text-field
      name ='bio'
      label='Short Bio'
      id='bio'
      v-model='bio'
      multi-line
      type='text'>
    </v-text-field>
  </v-flex>
</v-layout>
<v-layout row>
  <v-flex xs12>
    <v-btn type='submit'>Save</v-btn>
    <v-btn v-on:click='revert'>Cancel</v-btn>
  </v-flex>
</v-layout>
</v-form>
</v-container>
</v-card-text>
</v-card>
</v-flex>
</v-container>
</template>

<script>
import VueAvatar from './VueAvatar.vue'
import VueAvatarScale from './VueAvatarScale.vue'
import {mapGetters, mapActions} from 'vuex'
import {db, firestore} from '@/firebase/firebase'
export default {
  data () {
    return {
      userName: '',
      firstName: '',
      lastName: '',
      bio: '',
      organization: '',
      editMode: false,
      avatarDialog: false,
      avatar: '',
      tempAvatar: '',
      image: ''
    }
  },
  components: {
    VueAvatar,
    VueAvatarScale
  },
  computed: {
    ...mapGetters('user', {
      displayName: 'displayName',
      emailAddress: 'emailAddress',
      currentUser: 'currentUser'
    }),
    avatarDefault () {
      return this.userName.charAt(0)
    }
  },
  mounted: function () {
    this.userName = this.userInfo.userName
    this.firstName = this.userInfo.firstName
    this.lastName = this.userInfo.lastName
    this.bio = this.userInfo.bio
    this.organization = this.userInfo.organization

    let storageRef = firestore.ref('/user/' + this.currentUser + '/avatar.png')
    let that = this
    storageRef.getDownloadURL().then(function (url) {
      that.avatar = url
      that.tempAvatar = url
    }).catch(function (error) {
      switch (error.code) {
        case 'storage/object_not_found':
          break
        default:
          console.error(error)
      }
    })
  },
  methods: {
    ...mapActions('user', {
      setDisplayName: 'setDisplayName'
    }),
    saveAvatar () {
      if (!this.tempAvatar.startsWith('https:')) {
        var avatarRef = firestore.ref('/user/' + this.currentUser + '/avatar.png')
        var that = this
        avatarRef.putString(this.tempAvatar, 'data_url').then(function (snapshot) {
          that.avatar = snapshot.downloadURL
          that.tempAvatar = snapshot.downloadURL
        })
      }
    },
    onSetUserInfo () {
      // update profile information here
      // update avatar here
      this.setDisplayName({userName: this.userName})

      this.$firebaseRefs.userInfo.set(
        {
          userName: this.userName,
          firstName: this.firstName,
          lastName: this.lastName,
          bio: this.bio,
          organization: this.organization
        })
      this.saveAvatar()
      this.editMode = false
    },
    revert () {
      this.userName = this.userInfo.userName
      this.firstName = this.userInfo.firstName
      this.lastName = this.userInfo.lastName
      this.bio = this.userInfo.bio
      this.organization = this.userInfo.organization
      this.tempAvatar = this.avatar
      this.editMode = false
      console.log('revert')
    },
    onChangeScale (scale) {
      this.$refs.vueavatar.changeScale(scale)
    },
    avatarEditDone () {
      var img = this.$refs.vueavatar.getImageScaled()
      this.tempAvatar = img.toDataURL()
      this.avatarDialog = false
    },
    onImageReady (scale) {
      this.$refs.vueavatarscale.setScale(scale)
    },
    revertTempAvatar () {
      this.avatarDialog = false
      this.tempAvatar = this.avatar
    }
  },
  firebase: function () {
    return {
      userInfo: {
        source: db.ref('/users/' + this.currentUser + '/info'),
        asObject: true,
        readyCallback: function () {
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/UserInfo.vue